import { render, staticRenderFns } from "./ReleaseNotesModal.vue?vue&type=template&id=0d33b810&"
import script from "./ReleaseNotesModal.vue?vue&type=script&lang=js&"
export * from "./ReleaseNotesModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports